import { Component, Input } from '@angular/core';
import { HardCopyActivityLifeCycle } from '../models/hardcopyactivity-life-cycle';
import { AuditConstants } from '../../../app/shared/constants/audit-constants';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-hardcopyactivity-audit-life-cycle',
  templateUrl: './hardcopyactivity-audit-life-cycle.component.html',
  styleUrls: ['./hardcopyactivity-audit-life-cycle.component.scss']
})
export class HardcopyactivityAuditLifeCycleComponent {
  @Input() auditLifecycleInput: HardCopyActivityLifeCycle[] = [];
  private statusOrder = AuditConstants.hardCopyActivityStatusOrder;
  ngOnInit(): void {
    this.calculateStatusForLifeCycleFlow();
  }

  calculateStatusForLifeCycleFlow = () => {
    const datePipe = new DatePipe('en-US');
    this.auditLifecycleInput.forEach((entity, i) => {
      const currentPhaseIndex = this.statusOrder.indexOf(entity.statusName);
      const prevEntity = this.auditLifecycleInput[i - 1];
      const prevPhaseIndex = prevEntity ? this.statusOrder.indexOf(prevEntity.statusName) : -1;
      entity.arrowColor = currentPhaseIndex > prevPhaseIndex ? 'green-arrow' : 'red-arrow';
      entity.userDetails = entity.userDetails
        .map((user) => ({ ...user, date: datePipe.transform(user.transactionDate, 'dd-MMM-yy'), }))
        .sort((a, b) => {
          if (!a.date || !b.date) {
            return 0;
          }
          return a.date.localeCompare(b.date) || a.userName.localeCompare(b.userName);
        });
    });
  }
}
